// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T3_K","index":"styles_index__2IigV"};